import React, { useState, useEffect, useCallback } from "react";
import $ from "jquery";
import { debounce } from "lodash";
import { BottomScrollListener } from "react-bottom-scroll-listener";
import ErrorModal from "./ErrorModal";
import SaleChannelSelectorModal from "./SaleChannelSelectorModal";
import {
  LOW_DEBOUNCE_TIME,
  VERY_HIGH_DEBOUNCE_TIME,
  buildEditableSelect,
  parseGradeOverall,
  parseCategoryName,
  parseLanguage,
  titleize,
  pluralize,
  getArtwork,
  fullName,
  parseLanguageAcronim,
  parseGameName,
  DEFAULT_PER_PAGE_PARAM,
  CURRENCY_EURO,
  isDefined,
  parseAmount,
  scrollHtmlElementIntoView,
  addHtmlElementClass,
  removeHtmlElementClass,
  getHtmlElement,
  checkHtmlElement,
  compareStrings,
  is10Perfect,
  getGradingNameFromGrade,
  saleItemColorState
} from "../../utils/utils";
import I18n from 'i18n.js.erb'
import IconTooltip from "./IconTooltip";
import LanguageFlag from "./LanguageFlag";
import SuccessFlashMessage from "./SuccessFlashMessage";
import ShowBlueprintImageFrontImage from "./ShowBlueprintImageFrontImage";
import RarityIcon from "./RarityIcon";
import ExpansionIcon from "./ExpansionIcon";
import GameIcon from "./GameIcon";
import TransferCertificatesModal from "./TransferCertificatesModal";
import LoopPriceEditModal from "./LoopPriceEditModal";
import ProductActionMenu from "./ProductActionMenu";
import UpdateSaleItemsStateButton from "./UpdateSaleItemsStatesButton";
import FullScreenLoadingOverlay from "./FullScreenLoadingOverlay";
import GradingCertificate from "./GradingCertificate";


const GradeOverallContainer = ({ product, viewMode, handleDisplayProductActionsMenu }) => {
  return (
    <div
      className={`br-50px ${(is10Perfect(product.current_grading) ? 'bg-gold-aig-gradient p-2px' : 'bg-aig-gradient p-2px')}`}>
      <div className={`d-flex justify-content-center align-items-center text-center p-0 w-100 br-50px bg-white
                                                    grading-container-${viewMode === 'large' ? viewMode : 'medium'}`}
        id={`product_content_${product.id}_div`}
        onClick={(e) => {
          handleDisplayProductActionsMenu(product)
          e.stopPropagation();
        }}
      >
        <span className={`grading-${viewMode === 'large' ? viewMode : 'medium'} 
          ${is10Perfect(product.current_grading) ? 'text-gold-aig-gradient' : 'text-aig-gradient'}`}
          id={`product_content_${product.id}_grading`}>
          {parseGradeOverall(product.current_grading, true)}
        </span>
        <img src="/images/icons/three_dots.svg"
          className={`d-none`}
          id={`product_content_${product.id}_info`}
          width={`${viewMode === 'large' ? '36' : '24'}`} height={`${viewMode === 'large' ? '36' : '24'}`}
        />
      </div>
    </div>
  );
}

const MyCollectionPage = ({
  sale_channels,
  userId,
  categories,
  games,
  eras,
  expansions,
  languages,
  versions,
  rarities,
  label_languages,
  closedSubmissionsList,
  sorting_options,
  enableProFunctionalities,
  enableLoopMerchantFunctionalities,
  enableSaleFunctionalities,
  renderActionsBar,
  locale,
  view_mode,
  enableFilters,
  saleChannelByUserSaleItems,
  showListings,
  initialGameId
}) => {

  const saleChannels = JSON.parse(sale_channels);
  const availableSaleChannels = saleChannels.filter(sale_channel => sale_channel.available)
  const [initCompleted, setInitCompleted] = useState(false)
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([])
  const [selectedProductsIds, setSelectedProductsIds] = useState([])
  const [selectedGradingCertificatesNumbers, setSelectedGradingCertificatesNumbers] = useState([])
  const [allProductsIds, setAllProductsIds] = useState([])
  const [defaultCondition, setDefaultCondition] = useState(null)
  const [defaultBatch, setDefaultBatch] = useState('')
  const initialFilters = {
    name: null, collector_number: null, category_id: null, game_id: initialGameId || null, era_id: null, expansion_id: null,
    language_filter: null, version: null, rarity: null, encasing: null, condition: null, label_language: null,
    submission_list_id: null, on_sale_on_sale_channel: null, on_sale_on_sale_channel_id: null, batch: null,
    min_price: null, grade_from: null, grade_to: null, per_page: DEFAULT_PER_PAGE_PARAM, state: null,
    serial_number: null, sort_by: null, sorting_direction: 'asc'
  }
  const [filters, setFilters] = useState(initialFilters)
  const [viewMode, setViewMode] = useState(view_mode ? view_mode : (window.innerWidth < 768 ? 'shrinked_medium' : 'medium'));
  const [viewModeSelected, setViewModeSelected] = useState(false);
  const [changeViewMode, setChangeViewMode] = useState(false);
  const [erasForFilter, setErasForFilter] = useState(eras)
  const [expansionsForFilter, setExpansionsForFilter] = useState(expansions)
  const [languagesForFilter, setLanguagesForFilter] = useState(languages)
  const [raritiesForFilter, setRaritiesForFilter] = useState(rarities)
  const [versionsForFilter, setVersionsForFilter] = useState(versions)
  const [page, setPage] = useState(1);
  const [hasLoadedAllProducts, setHasLoadedAllProducts] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [showSaleChannelSelectorModal, setShowSaleChannelSelectorModal] = useState(false)
  const [showSuccessFlashMessage, setShowSuccessFlashMessage] = useState(false)
  const [successFlashMessage, setSuccessFlashMessage] = useState(null)
  const [showTransferCertificatesModal, setShowTransferCertificatesModal] = useState(false)
  const [showLoopPriceEditModal, setShowLoopPriceEditModal] = useState(false)
  const [productsToEditLoopPrice, setProductsToEditLoopPrice] = useState([])
  const [isUpdatingLoopPrice, setIsUpdatingLoopPrice] = useState(false)
  const [toUserBlockchainKey, setToUserBlockchainKey] = useState(false)
  const [previousToUserBlockchainKey, setPreviousToUserBlockchainKey] = useState(false)
  const [transferCertificatesErrorMessage, setTransferCertificatesErrorMessage] = useState(false)
  const [filtersEnabled, setFiltersEnabled] = useState(enableFilters && window.innerWidth > 768);
  const [actionsBarOpen, setActionsBarOpen] = useState(window.innerWidth > 768);
  const [checkAll, setCheckAll] = useState(false);
  const [allProductsSelected, setAllProductsSelected] = useState(false);
  const [actionMenuProduct, setActionMenuProduct] = useState(null);
  const [actionMenuProductGradingCertificate, setActionMenuProductGradingCertificate] = useState(null);
  const [productToShowGradingCertificate, setProductToShowGradingCertificate] = useState(null)
  const [productToTransferCertificate, setProductToTransferCertificate] = useState(null)
  const [showCertificate, setShowCertificate] = useState(false)
  const [loadingCsvData, setLoadingCsvData] = useState(false)
  const [onTopPage, setOnTopPage] = useState(true);
  const [cardsAnimationDivider, setCardsAnimationDivider] = useState(Number.MAX_SAFE_INTEGER);
  const [showSaleData, setShowSaleData] = useState(showListings === true);
  const [showLoopPrices, setShowLoopPrices] = useState(true);
  const [showProData, setShowProData] = useState(false);
  const [creatingSaleItems, setCreatingSaleItems] = useState(false);
  const availableSaleChannelsMetaNames = availableSaleChannels.map(sale_channel => sale_channel.meta_name).join(", ");
  const presentSaleItems = saleChannelByUserSaleItems?.length > 0
  let defaultTipMessage = I18n.t('js.myCollectionEditPage.tipMessages.defaultTipMessage')
  const [tipMessage, setTipMessage] = useState(defaultTipMessage);

  // console.log("products: ", products);
  // console.log("saleChannels: ", saleChannels);

  useEffect(() => {
    if (initCompleted && products.length === 0) {
      getProducts()
    }
  }, [products, initCompleted]);

  useEffect(() => {
    if (!initCompleted) {
      setInitCompleted(true)
      // Se c'è un initialGameId, applica i filtri per quel game
      if (initialGameId) {
        updateFiltersForGame(initialGameId)
      }
    }
  }, []);

  useEffect(() => {
    if (filters.expansion_id) {
      setTimeout(() => { $("span.select2-selection.select2-selection--single").addClass("selected-label"); }, 50)
      setSelectedProducts([])
    }
    else {
      setSelectedProducts([]);
      $(".select2-selection.select2-selection--single").removeClass("selected-label");
    }
  }, [filters]);

  useEffect(() => {
    if (initCompleted) {
      debouncedUpdateFilters();
      return debouncedUpdateFilters.cancel;
    }
  }, [filters.name, filters.collector_number, filters.batch, filters.min_price, filters.serial_number, debouncedUpdateFilters]);

  useEffect(() => {
    if (initCompleted) {
      debouncedUpdateBatch();
      return debouncedUpdateBatch.cancel;
    }
  }, [defaultBatch, debouncedUpdateBatch]);

  useEffect(() => {
    setSelectedProductsIds(selectedProducts.map(p => { return p.id }))
    setSelectedGradingCertificatesNumbers(selectedProducts.map(p => { return p.current_grading?.serial_number }))
  }, [selectedProducts])


  const handleChangeExpansionFilter = (e) => {
    getProductsByMatchingFilters('expansion_id', e.target.value)
  }


  useEffect(() => {
    buildEditableSelect(handleChangeExpansionFilter)
  }, [filters]);

  useEffect(() => {
    if (defaultCondition)
      handleUpdateProducts('condition', defaultCondition);
  }, [defaultCondition]);


  useEffect(() => {
    if (loadingCsvData)
      setTimeout(() => setLoadingCsvData(false), allProductsIds.length);
  }, [loadingCsvData]);


  useEffect(() => {
    const handleOnScroll = (e) => {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      setOnTopPage(scrollTop === 0);
    }

    document.addEventListener('scroll', handleOnScroll);

    return () => {
      document.removeEventListener('scroll', handleOnScroll);
    }
  }, []);


  useEffect(() => {
    if (viewMode && initCompleted)
      setChangeViewMode(true);
  }, [viewMode]);


  useEffect(() => {
    if (changeViewMode) {
      setChangeViewMode(false);
      if (checkAll)
        setTimeout(() => handleSelectAllProducts(true), 100)
    }
  }, [changeViewMode]);


  useEffect(() => {
    if (actionMenuProduct) {
      removeHtmlElementClass(document, `product_header_${actionMenuProduct.id}`, 'bg-aig-gradient-light');
      removeHtmlElementClass(document, `product_header_${actionMenuProduct.id}`, 'bg-gold-aig-gradient-light');
      addHtmlElementClass(document, `product_details_container_${actionMenuProduct.id}`, 'color-white');
      addHtmlElementClass(document, `product_details_${actionMenuProduct.id}`, 'color-white');
      removeHtmlElementClass(document, `product_details_${actionMenuProduct.id}`, 'color-dark-gray-2');
      addHtmlElementClass(document, `product_rarity_${actionMenuProduct.id}`, 'color-white');
      removeHtmlElementClass(document, `product_rarity_${actionMenuProduct.id}`, 'color-dark-gray-2');
      addHtmlElementClass(document, `product_edition_${actionMenuProduct.id}`, 'color-white');
      removeHtmlElementClass(document, `product_edition_${actionMenuProduct.id}`, 'color-dark-gray-2');
      addHtmlElementClass(document, `product_header_${actionMenuProduct.id}`, `bg-${is10Perfect(actionMenuProduct.current_grading) ? 'gold-' : ''}aig-gradient-medium-light`);
      addHtmlElementClass(document, `product_header_${actionMenuProduct.id}`, 'z-index-99');
      removeHtmlElementClass(document, `actions_menu_${actionMenuProduct.id}`, 'd-none');
    } else {
      removeHtmlElementClass(document, `product_details_container_${actionMenuProduct?.id}`, 'color-white');
      removeHtmlElementClass(document, `product_details_${actionMenuProduct?.id}`, 'color-white');
      addHtmlElementClass(document, `product_details_${actionMenuProduct?.id}`, 'color-dark-gray-2');
      removeHtmlElementClass(document, `product_rarity_${actionMenuProduct?.id}`, 'color-white');
      addHtmlElementClass(document, `product_rarity_${actionMenuProduct?.id}`, 'color-dark-gray-2');
      removeHtmlElementClass(document, `product_edition_${actionMenuProduct?.id}`, 'color-white');
      addHtmlElementClass(document, `product_edition_${actionMenuProduct?.id}`, 'color-dark-gray-2');
      addHtmlElementClass(document, `product_header_${actionMenuProduct?.id}`, `bg-${is10Perfect(actionMenuProduct?.current_grading) ? 'gold-' : ''}aig-gradient-light`);
      removeHtmlElementClass(document, `product_header_${actionMenuProduct?.id}`, 'bg-aig-gradient-medium-light');
      removeHtmlElementClass(document, `product_header_${actionMenuProduct?.id}`, 'bg-gold-aig-gradient-medium-light');
    }
  }, [actionMenuProduct])


  // Funzione che aggiorna diverse variabili dello stato del componente con i nuovi dati ricevuti dal server
  const updateState = (data) => {
    setAllProductsIds(data.products_ids)
  }


  // Funzione che esegue il parsing dell'endpoint del server da cui il componente ottiene i dati da renderizzare a video
  const parseProductsUrl = (format, newPage, perPageOverride) => {
    let url = `/users/${userId}/certificates.${format ? format : 'json'}?page=${newPage ? newPage : page}`
    if (perPageOverride)
      url += `&per_page=${perPageOverride}`
    Object.entries(filters).forEach(([fieldName, fieldValue]) => {
      // Quando viene forzato un per_page (es. export CSV) ignoriamo quello dei filtri
      if (perPageOverride && fieldName === 'per_page')
        return
      if (fieldValue !== null)
        url += `&${fieldName}=${fieldValue}`
      else {
        if (fieldName === 'sort_by')
          url += `&${fieldName}=id`
        if (fieldName === 'sorting_direction')
          url += `&${fieldName}=desc`
      }
    })
    return url;
  }


  // Funzione che permette di ottenere dal server nuove carte da renderizzare sull'interfaccia grafica
  const getProducts = () => {
    if (!hasLoadedAllProducts) {
      setCardsAnimationDivider(parseInt(filters.per_page, 10) || DEFAULT_PER_PAGE_PARAM);
      fetch(parseProductsUrl(), {
        method: 'GET'
      })
        .then(response => response.json())
        .then((data) => {
          updateState(data)
          setLoading(false);
          setLoadingMore(false);
          appendProducts(data.products);
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che permette di concatenare le nuove carte ottenute del server all'array che contiene tutte le
  // carte da mostrare sull'interfaccia grafica all'utente
  const appendProducts = (newProducts) => {
    setProducts(products.concat(newProducts));
    setPage(page + 1)
    if (newProducts.length < (parseInt(filters.per_page, 10) || DEFAULT_PER_PAGE_PARAM))
      setHasLoadedAllProducts(true);
  }


  // Funzione che permette di ottenere dal server le carte della my collection dell'utente che matchano con i filtri
  // di ricerca da lui specificati sull'interfaccia grafica
  const getProductsByMatchingFilters = (filter, value) => {
    const newFilters = { ...filters }
    newFilters[filter] = value;
    if (filter === 'game_id') {
      newFilters['era_id'] = null;
      newFilters['expansion_id'] = null;
      newFilters['language_filter'] = null;
      newFilters['rarity'] = null;
      newFilters['version'] = null;
    }
    if (filter === 'era_id')
      newFilters['expansion_id'] = null;
    updateFilters(newFilters)
  }


  //Funzione che esegue l'update debouncato del filtro di ricerca delle carte per nome
  const debouncedUpdateFilters = useCallback(
    debounce(() => updateFilters(filters), LOW_DEBOUNCE_TIME),
    [filters.name, filters.collector_number, filters.batch, filters.min_price, filters.serial_number]
  );


  // Funzione che esegue l'update debouncato del numero di lotto da settare per tutti
  // i prodotti filtrati dall'utente sulla sua my collection
  const debouncedUpdateBatch = useCallback(
    debounce(() => {
      handleUpdateProducts('batch', defaultBatch)
    }, VERY_HIGH_DEBOUNCE_TIME),
    [defaultBatch]
  );


  // Funzione che setta il nuovo filtro di ricerca delle carte per nome o per prezzo minimo
  function onChangeDebouncedFilterHandler(key, value) {
    const newFilters = { ...filters }
    newFilters[key] = value;
    setFilters(newFilters)
  }


  // Funzione che aggiorna tutte le opzioni dei filtri quando l'utente seleziona un game specifico
  function updateFiltersForGame(game_id) {
    if (!game_id || game_id === "") {
      setErasForFilter(eras)
      setExpansionsForFilter(expansions)
      setLanguagesForFilter(languages)
      setRaritiesForFilter(rarities)
      setVersionsForFilter(versions)
      return
    }

    setErasForFilter(eras.filter(function(era) { return era.game_id == game_id }))
    setExpansionsForFilter(expansions.filter(function(expansion) { return expansion.game_id == game_id }))
    setLanguagesForFilter(languages.filter(function(language) { return language.game_id == game_id }))
    setRaritiesForFilter(rarities.filter(function(rarity) { return rarity.game_id == game_id }))
    setVersionsForFilter(versions.filter(function(version) { return version.game_id == game_id }))
  }

  // Funzione che aggiorna le opzioni dal filtro di ricerca dei products per espansioni
  function filterExpansionsByEraAndGame(era_id, game_id) {
    setExpansionsForFilter(expansions.filter(function(expansion) {
      return (!era_id || era_id === "" || expansion.era_id == era_id) &&
             (!game_id || game_id === "" || expansion.game_id == game_id)
    }))
  }


  // Funzione che aggiorna i filtri di ricerca delle carte specificate dall'utente sull'interfaccia grafica e rilancia
  // la ricerca sulla carte della my collection che matchano con i nuovi filtri specificati
  const updateFilters = (newFilters) => {
    setFilters(newFilters);
    setLoading(true);
    setPage(1);
    setHasLoadedAllProducts(false);
    setProducts([]);

    setCheckAll(false);
    setAllProductsSelected(false);
    setActionMenuProduct(null);
    checkHtmlElement(document, 'select_all_products', false);
  }


  // Funzione che si occupa di resettare tutti i filtri di ricerca specificati dall'utente sull'interfaccia grafica
  const handleResetFilters = () => {
    $('.select2-custom').val('').trigger('change.select2');
    updateFilters(initialFilters);
    setExpansionsForFilter(expansions)
  }


  // Funzione che permette all'utente di modificare i prodotti da lui selezionati sull'interfaccia grafica
  function handleUpdateProducts(key, value) {
    if (enableProFunctionalities || enableLoopMerchantFunctionalities) {
      const url = `/users/${userId}/certificates/update_all_products`;

      const body = {
        products_ids: selectedProductsIds
      }
      body[key] = value

      fetch(url + ".json", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((response) => {
          if (!response.ok)
            throw Error("An error occour during saving data on the database");
          else
            return response.json()
        })
        .then((data) => {
          let newProducts = products.map((product) => {
            if (selectedProductsIds.includes(product.id)) {
              if (['condition', 'price'].includes(key)) {
                const newProduct = { ...product }
                newProduct[key] = value
                return newProduct
              } else if (key === 'batch' && product.condition !== 'new') {
                const newProduct = { ...product }
                newProduct['batch'] = value
                return newProduct
              }
            }
            return product;
          })
          setProducts(newProducts);
          setShowSuccessFlashMessage(true);
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }

  // Funzione che verifica se un certo prodotto sia stato selezionato dall'utente sull'interfaccia grafica
  const isSelected = (product) => {
    if (product) {
      const elem = getHtmlElement(document, `product_${product.id}`);
      return elem.classList.contains('selected_product');
    }
    return false
  }


  // Funzione che gestisce il rendering del contenuto di un prodotto sull'interfaccia grafica
  const handleDisplayProductContent = (product, display, mouseMove = false) => {
    if (display) {
      if (mouseMove) {
        addHtmlElementClass(document, `product_content_${product.id}_grading`, 'd-none');
        removeHtmlElementClass(document, `product_content_${product.id}_info`, 'd-none');
      }
      if (isSelected(product)) {
        removeHtmlElementClass(document, `product_details_${product.id}`, 'color-dark-gray-2');
        addHtmlElementClass(document, `product_rarity_${product.id}`, 'color-white');
        removeHtmlElementClass(document, `product_rarity_${product.id}`, 'color-dark-gray-2');
        addHtmlElementClass(document, `product_edition_${product.id}`, 'color-white');
        removeHtmlElementClass(document, `product_edition_${product.id}`, 'color-dark-gray-2');
        addHtmlElementClass(document, `product_details_container_${product.id}`, 'color-white');
        addHtmlElementClass(document, `product_details_${product.id}`, 'color-white');
        removeHtmlElementClass(document, `product_header_${product.id}`, 'bg-aig-gradient-light');
        removeHtmlElementClass(document, `product_header_${product.id}`, 'bg-gold-aig-gradient-light');
        addHtmlElementClass(document, `product_header_${product.id}`, `bg-${is10Perfect(product.current_grading) ? 'gold-' : ''}aig-gradient`);
        // removeHtmlElementClass(document, `product_header_${product.id}`, 'bg-aig-gradient-medium-light');
        // removeHtmlElementClass(document, `product_header_${product.id}`, 'bg-gold-aig-gradient-medium-light');
      }
      if (!isSelected(product) && actionMenuProduct?.id !== product.id) {
        // addHtmlElementClass(document, `product_header_${product.id}`, `bg-${is10Perfect(product.current_grading) ? 'gold-' : ''}aig-gradient-medium-light`);
      }
    } else {
      if (mouseMove && actionMenuProduct?.id !== product.id) {
        removeHtmlElementClass(document, `product_content_${product.id}_grading`, 'd-none');
        addHtmlElementClass(document, `product_content_${product.id}_info`, 'd-none');
      }
      if (!isSelected(product)) {
        if (actionMenuProduct?.id !== product.id) {
          addHtmlElementClass(document, `product_header_${product.id}`, `bg-${is10Perfect(product.current_grading) ? 'gold-' : ''}aig-gradient-light`);
          removeHtmlElementClass(document, `product_header_${product.id}`, 'bg-aig-gradient-medium-light');
          removeHtmlElementClass(document, `product_header_${product.id}`, 'bg-gold-aig-gradient-medium-light');
          removeHtmlElementClass(document, `product_details_container_${product.id}`, 'color-white');
          removeHtmlElementClass(document, `product_details_${product.id}`, 'color-white');
          addHtmlElementClass(document, `product_details_${product.id}`, 'color-dark-gray-2');
          removeHtmlElementClass(document, `product_rarity_${product.id}`, 'color-white');
          addHtmlElementClass(document, `product_rarity_${product.id}`, 'color-dark-gray-2');
          removeHtmlElementClass(document, `product_edition_${product.id}`, 'color-white');
          addHtmlElementClass(document, `product_edition_${product.id}`, 'color-dark-gray-2');
        } else {
          addHtmlElementClass(document, `product_header_${product.id}`, `bg-${is10Perfect(product.current_grading) ? 'gold-' : ''}aig-gradient-medium-light`);
        }
        removeHtmlElementClass(document, `product_header_${product.id}`, `bg-aig-gradient`);
        removeHtmlElementClass(document, `product_header_${product.id}`, 'bg-gold-aig-gradient');
      }
    }
  }


  // Funzione che gestisce l'apertura del menù di un articolo
  const handleDisplayProductActionsMenu = (product) => {
    removeHtmlElementClass(document, `product_header_${actionMenuProduct?.id}`, 'z-index-99');
    addHtmlElementClass(document, `actions_menu_${actionMenuProduct?.id}`, 'd-none');
    removeHtmlElementClass(document, `product_header_${actionMenuProduct?.id}`, 'bg-aig-gradient-medium-light');
    removeHtmlElementClass(document, `product_header_${actionMenuProduct?.id}`, 'bg-gold-aig-gradient-medium-light');

    const newActionMenuProduct = actionMenuProduct?.id && actionMenuProduct?.id === product.id ? null : product;

    if (newActionMenuProduct) {
      removeHtmlElementClass(document, `product_content_${actionMenuProduct?.id}_grading`, 'd-none');
      addHtmlElementClass(document, `product_content_${actionMenuProduct?.id}_info`, 'd-none');
      if (!isSelected(actionMenuProduct)) {
        removeHtmlElementClass(document, `product_details_container_${actionMenuProduct?.id}`, 'color-white');
        removeHtmlElementClass(document, `product_details_${actionMenuProduct?.id}`, 'color-white');
        addHtmlElementClass(document, `product_details_${actionMenuProduct?.id}`, 'color-dark-gray-2');
        removeHtmlElementClass(document, `product_rarity_${actionMenuProduct?.id}`, 'color-white');
        addHtmlElementClass(document, `product_rarity_${actionMenuProduct?.id}`, 'color-dark-gray-2');
        removeHtmlElementClass(document, `product_edition_${actionMenuProduct?.id}`, 'color-white');
        addHtmlElementClass(document, `product_edition_${actionMenuProduct?.id}`, 'color-dark-gray-2');
        addHtmlElementClass(document, `product_header_${actionMenuProduct?.id}`, `bg-${is10Perfect(actionMenuProduct?.current_grading) ? 'gold-' : ''}aig-gradient-light`);
      }
    } else {
      if (isSelected(actionMenuProduct)) {
        addHtmlElementClass(document, `product_header_${actionMenuProduct?.id}`, `bg-${is10Perfect(actionMenuProduct?.current_grading) ? 'gold-' : ''}aig-gradient`);
      } else {
        addHtmlElementClass(document, `product_header_${actionMenuProduct?.id}`, `bg-${is10Perfect(actionMenuProduct?.current_grading) ? 'gold-' : ''}aig-gradient-light`);
        removeHtmlElementClass(document, `product_details_container_${actionMenuProduct?.id}`, 'color-white');
        removeHtmlElementClass(document, `product_details_${actionMenuProduct?.id}`, 'color-white');
        addHtmlElementClass(document, `product_details_${actionMenuProduct?.id}`, 'color-dark-gray-2');
        removeHtmlElementClass(document, `product_rarity_${actionMenuProduct?.id}`, 'color-white');
        addHtmlElementClass(document, `product_rarity_${actionMenuProduct?.id}`, 'color-dark-gray-2');
        removeHtmlElementClass(document, `product_edition_${actionMenuProduct?.id}`, 'color-white');
        addHtmlElementClass(document, `product_edition_${actionMenuProduct?.id}`, 'color-dark-gray-2');
      }
    }

    setActionMenuProduct(newActionMenuProduct);
  }


  // Funzione che gestisce la selezione di un prodotto da parte dell'utente sull'interfaccia grafica
  const handleSelectProduct = (product) => {
    let selected = false;

    if (!isSelected(product)) {
      selected = true;
      addHtmlElementClass(document, `product_${product.id}`, 'selected_product');
      handleDisplayProductContent(product, true);
    } else {
      removeHtmlElementClass(document, `product_${product.id}`, 'selected_product');
      handleDisplayProductContent(product, false);
      setAllProductsSelected(false);
    }

    if (renderActionsBar) {
      if (selected)
        setSelectedProducts([...selectedProducts, product]);
      else
        setSelectedProducts(selectedProducts.filter(p => p.id != product.id));
    }
  }


  // Funzione che gestisce la selezione di tutti i prodotti da parte dell'utente sull'interfaccia grafica
  const handleSelectAllProducts = (check) => {
    if (renderActionsBar) {
      setSelectedProducts(check ? products : []);
      setCheckAll(check);

      for (const product of products) {
        if (check) {
          addHtmlElementClass(document, `product_${product.id}`, 'selected_product');
          handleDisplayProductContent(product, true);
        }
        else {
          removeHtmlElementClass(document, `product_${product.id}`, 'selected_product');
          handleDisplayProductContent(product, false);
        }
      }
    }
  }


  // Funzione che gestisce il trasferimento dei certificati di gradazione dall'utente corrente a un altro utente
  // di sua scelta (se già registrato sul sistema)
  const handleTransferGradingCertificates = (toUserBlockchainKey, productsToTransfer) => {
    const certificatesOnError = productsToTransfer
      .filter(product => product?.sale_items?.length > 0 && product.sale_items.some(sale_item => ['draft', 'listing', 'scheduled', 'on_sale', 'expired'].includes(sale_item?.state)))
      .map(product => { return product.current_grading.extended_serial_number; })
      .filter(serial => serial !== undefined)
      .toString();


    if (certificatesOnError.length > 0) {
      setTransferCertificatesErrorMessage(pluralize(certificatesOnError.split(',').length, "myCollectionEditPage.transferCertificatesErrors.onSaleProduct").replace(':certificate_number', certificatesOnError));
      return;
    }
    if (toUserBlockchainKey !== previousToUserBlockchainKey) {
      const url = `/users/${userId}/products/ownerships/transfer.json`

      const productsId = productsToTransfer.map(product => product.id)

      const body = {
        products_ids: productsId,
        to_user_blockchain_key: toUserBlockchainKey
      }

      setPreviousToUserBlockchainKey(toUserBlockchainKey);
      fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((response) => {
          if (!response.ok) {
            console.log('response: ', response);
            throw Error(I18n.t(`js.myCollectionEditPage.transferCertificatesErrors.${response.status}`));
          }
          else
            return response.json()
        })
        .then((data) => {
          let newProducts = products.filter((product) => !productsId.includes(product.id));
          setProducts(newProducts);

          let allNewProductsIds = allProductsIds.filter((productId) => !productsId.includes(productId));
          setAllProductsIds(allNewProductsIds);

          let newSelectedProducts = selectedProducts.filter((product) => !productsId.includes(product.id));
          setSelectedProducts(newSelectedProducts);

          setSuccessFlashMessage(pluralize(productsId.length, 'myCollectionEditPage.transferCertificateComppleted'));
          setShowSuccessFlashMessage(true);
          setActionMenuProduct(null)
          setActionMenuProductGradingCertificate(null)

          handleCloseTransferCertificatesModal();
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setTransferCertificatesErrorMessage(error.message);
        });
    }
  }


  // Funzione che gestisce la chiusura della modale che consente all'utente di trasferire certificati di gradazione a
  // un altro utente di sua scelta registrato a sistema
  const handleCloseTransferCertificatesModal = () => {
    setShowTransferCertificatesModal(false);
    setTransferCertificatesErrorMessage(null);
    setToUserBlockchainKey(null);
    setPreviousToUserBlockchainKey(null);
    setProductToTransferCertificate(null);
  }

  const handleCloseLoopPriceEditModal = () => {
    setShowLoopPriceEditModal(false);
    setProductsToEditLoopPrice([]);
  }

  const handleUpdateLoopPrice = (productsToUpdate, newPrice) => {
    setIsUpdatingLoopPrice(true);
    const url = `/users/${userId}/certificates/update_all_products`;
    const productIds = productsToUpdate.map(p => p.id);
    const isSingleProduct = productsToUpdate.length === 1;

    fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        products_ids: productIds,
        price: newPrice
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then(() => {
        const updatedProducts = products.map((p) => {
          if (productIds.includes(p.id)) {
            return { ...p, price: newPrice };
          }
          return p;
        });
        setProducts(updatedProducts);
        handleCloseLoopPriceEditModal();
        setSuccessFlashMessage(
          isSingleProduct
            ? I18n.t('js.loopPriceModal.successMessage')
            : I18n.t('js.loopPriceModal.successMessageBulk').replace(':count', productsToUpdate.length)
        );
        setShowSuccessFlashMessage(true);
      })
      .catch(() => {
        setShowErrorModal(true);
      })
      .finally(() => {
        setIsUpdatingLoopPrice(false);
      });
  }


  // Funzione che gestisce la creazione di sale_items sui possibili sale_channels
  const handleCreateSaleItems = (saleChannelId, productsToCreateSaleItems, saleItem = null) => {
    if (isDefined(saleItem))
      window.location = `/users/${userId}/sale_items?serial_number=${productsToCreateSaleItems[0].current_grading.serial_number}&sale_channel_id=${saleChannelId}`
    else {
      setCreatingSaleItems(true);
      const url = `/users/${userId}/sale_channels/${saleChannelId}/sale_items`;
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: productsToCreateSaleItems }),
      })
        .then((res) => {
          if (!res.ok)
            throw Error("An error occour during saving data on the database");
          else
            return res.json()
        })
        .then((data) => {
          setCreatingSaleItems(false);
          window.location = `/users/${userId}/sale_items`;
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setCreatingSaleItems(false);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che valorizza il titolo da renderizzare a video per un certo sale_item, in base al suo stato
  const saleItemTitleToRender = (saleItem) => {
    switch (saleItem.state) {
      case 'on_sale':
        return I18n.t('js.indexSaleItems.saleMethods.' + saleItem.sale_method).toUpperCase()
      default:
        return I18n.t('js.indexSaleItems.states.' + saleItem.state).toUpperCase()
    }
  }


  // Funzione che renderizza a video i vari attributi di vendita di un certo sale_item, in base al suo stato corrente
  const saleItemAttributesToRender = (saleItem, viewMode) => {
    switch (saleItem.state) {
      case 'on_sale':
        switch (saleItem.sale_method) {
          case 'auction':
            return viewMode === 'shrinked_medium' ?
              [`${I18n.t('js.indexSaleItems.bar.amount_auction')}: ${parseAmount(saleItem.start_amount.toString(), 2)}${CURRENCY_EURO}`]
              :
              [
                `${I18n.t('js.indexSaleItems.bar.listedAt')} ${saleItem.listed_at}`,
                `${I18n.t('js.indexSaleItems.bar.amount_auction')}: ${parseAmount(saleItem.start_amount.toString(), 2)}${CURRENCY_EURO}`,
                `${pluralize(saleItem.offers_count, 'indexSaleItems.offersCountCompact').replace(":offers_count", saleItem.offers_count.toString())}`
              ];
          case 'fixed_price':
            return viewMode === 'shrinked_medium' ?
              [`${I18n.t('js.indexSaleItems.bar.amount_fixed_price')}: ${parseAmount(saleItem.start_amount.toString(), 2)}${CURRENCY_EURO}`]
              :
              [
                `${I18n.t('js.indexSaleItems.bar.listedAt')} ${saleItem.listed_at}`,
                `${I18n.t('js.indexSaleItems.bar.amount_fixed_price')}: ${parseAmount(saleItem.start_amount.toString(), 2)}${CURRENCY_EURO}`,
                `${pluralize(saleItem.offers_count, 'indexSaleItems.offersCountCompact').replace(":offers_count", saleItem.offers_count.toString())}`
              ]
        }
        break;
      case 'draft':
        return [`${I18n.t('js.indexSaleItems.bar.draft')}`]
      case 'listing':
        return [`${I18n.t('js.indexSaleItems.bar.listing')}`]
      case 'scheduled':
        return [`${I18n.t('js.indexSaleItems.bar.scheduled')}: ${saleItem.schedule_date}`]
      case 'expired':
        return [`${I18n.t('js.indexSaleItems.bar.expiredOn')}: ${saleItem.expiration_date}`]
      case 'sold':
        return ['']
      default:
        return [saleItem.created_at.split('-')[0].trim()]
    }
  }




  return (
    <React.Fragment>
      <div className={`${renderActionsBar ? 'position-relative min-h-vh-100' : ''}`}>
        <div className={`${renderActionsBar ? 'w-100 p-0 m-0' : ''}`}>
          {/*  HEADER DELLA PAGINA */}
          <div className="row d-block justify-content-center text-center bg-aig-gradient w-100 m-0 color-white py-4 border-bottom-radius-20px px-3 mb-5">
            <div id="pageTitle">
              <h2><b>{I18n.t('js.myCollectionEditPage.title')}</b></h2>
            </div>
          </div>




          <div id="my_collection_header_container">
            {/*  SEZIONE DEDICATA AI FILTRI DELLA PAGINA */}
            <div className="row mx-0 br-8px border-aiG-light-gray-imp bg-aiG-gray3-imp">
              <div className="col-12">
                <div className="row d-flex justify-content-between px-3 py-2">
                  <div className="w-50">
                    <div className="d-flex align-items-center justify-content-start text-left cursor-pointer"
                      onClick={(e) => setFiltersEnabled(!filtersEnabled)}>
                      <b>{I18n.t('js.filters.filters')}</b>
                      <img src={`/images/icons/black/arrow-${filtersEnabled ? 'up' : 'down'}.svg`} className="cursor-pointer ml-2"
                        alt="" width="10" height="10"
                      />
                    </div>
                  </div>

                  <div className="w-50">
                    <div className="d-flex align-items-center justify-content-end blue-label text-right cursor-pointer"
                      id="reset_filters"
                      onClick={handleResetFilters}>
                      <img src="/images/icons/refresh.svg" className="mr-2" id="reset"
                        alt="" width="15" height="15"
                      />
                      {I18n.t('js.filters.cancelFilters')}
                    </div>
                  </div>
                </div>


                <div className={`row slide-animation-container slide-${filtersEnabled ? 'down' : 'up'}`}>
                  <hr className="separator my-0 w-100" />

                  <div className="col-12 pr-0">
                    <div className="row w-100 py-2 pl-2">
                      <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                        <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.serialNumber')}</p>
                        <input
                          type="number"
                          value={filters.serial_number ? filters.serial_number : ""}
                          className={`form-control filter-input ${filters.title ? 'selected-label' : 'border-none'}`}
                          onChange={(e) => onChangeDebouncedFilterHandler('serial_number', e.target.value)}
                          name="serial_number_filter"
                          id="serial_number_filter"
                        />
                      </div>

                      <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                        <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.sort.cardName')}</p>
                        <input
                          type="text"
                          value={filters.name ? filters.name : ""}
                          className={`form-control filter-input ${filters.name ? 'selected-label' : 'border-none'}`}
                          onChange={(e) => onChangeDebouncedFilterHandler('name', e.target.value)}
                          name="card_name_filter"
                          id="card_name_filter"
                        />
                      </div>

                      <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                        <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.cardNumber')}</p>
                        <input
                          type="text"
                          value={filters.collector_number ? filters.collector_number : ""}
                          className={`form-control filter-input ${filters.collector_number ? 'selected-label' : 'border-none'}`}
                          onChange={(e) => onChangeDebouncedFilterHandler('collector_number', e.target.value)}
                          name="collector_number_filter"
                          id="collector_number_filter"
                        />
                      </div>

                      {
                        categories && categories.length > 1 &&
                        <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                          <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.category')}</p>
                          <select
                            className={`form-control filter-input ${filters.category_id ? 'selected-label' : 'border-none'} pl-2`}
                            value={filters.category_id ? filters.category_id : ""}
                            name="category_filter"
                            id="category_filter"
                            onChange={(e) => getProductsByMatchingFilters('category_id', e.target.value)}
                          >
                            <option value={""}></option>
                            {categories.map((category) => (
                              <option value={category.id} key={category.id}>
                                {parseCategoryName(category.name)}
                              </option>
                            ))}
                          </select>
                        </div>
                      }

                      {
                        games && games.length > 0 &&
                        <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                          <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.sort.cardGame')}</p>
                          <select
                            className={`form-control filter-input ${filters.game_id ? 'selected-label' : 'border-none'} pl-2`}
                            value={filters.game_id ? filters.game_id : ""}
                            name="game_filter"
                            id="game_filter"
                            onChange={(e) => {
                              updateFiltersForGame(e.target.value);
                              getProductsByMatchingFilters("game_id", e.target.value);
                            }}
                          >
                            <option value={""}></option>
                            {games.map((game) => (
                              <option value={game.id} key={game.id}>
                                {game.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      }

                      {
                        <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                          <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.sort.era')}</p>
                          <select
                            className={`form-control filter-input ${filters.era_id ? 'selected-label' : 'border-none'} pl-2`}
                            value={filters.era_id ? filters.era_id : ""}
                            name="era_filter"
                            id="era_filter"
                            disabled={!(erasForFilter && erasForFilter.length > 0)}
                            onChange={(e) => {
                              filterExpansionsByEraAndGame(e.target.value, filters.game_id);
                              getProductsByMatchingFilters("era_id", e.target.value);
                            }}
                          >
                            <option value={""}></option>
                            {erasForFilter.map((era) => (
                              <option value={era.id} key={era.id}>
                                {era.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      }

                      {
                        expansions && expansions.length > 0 &&
                        <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                          <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.sort.expansion')}</p>
                          <select
                            className="form-control filter-input select2-custom p-0"
                            value={filters.expansion_id ? filters.expansion_id : ""}
                            name="expansion_filter"
                            id="expansion_filter"
                            onChange={(e) => {
                            }}
                          >
                            <option value={""}></option>
                            {expansionsForFilter.map((expansion) => {
                              return <option value={expansion.id} key={expansion.id} label={expansion.icon}>
                                {expansion.name}
                              </option>
                            })}
                          </select>
                        </div>
                      }

                      {
                        languages && languages.length > 1 &&
                        <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                          <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.sort.cardLanguage')}</p>
                          <select
                            className={`form-control filter-input ${filters.language_filter ? 'selected-label' : 'border-none'} pl-2`}
                            value={filters.language_filter ? filters.language_filter : ""}
                            name="language_filter"
                            id="language_filter"
                            disabled={languagesForFilter.length === 0}
                            onChange={(e) => getProductsByMatchingFilters('language_filter', e.target.value)}
                          >
                            <option value={""}></option>
                            {Array.from(new Set(languagesForFilter.map((language) => language.name))).map((languageName) => (
                              <option value={languageName} key={languageName}>
                                {parseLanguage(languageName)}
                              </option>
                            ))}
                          </select>
                        </div>
                      }

                      {
                        rarities && rarities.length > 1 &&
                        <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                          <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.sort.rarity')}</p>
                          <select
                            className={`form-control filter-input ${filters.rarity ? 'selected-label' : 'border-none'} pl-2`}
                            value={filters.rarity ? filters.rarity : ""}
                            name="rarity_filter"
                            id="rarity_filter"
                            disabled={raritiesForFilter.length === 0}
                            onChange={(e) => getProductsByMatchingFilters('rarity', e.target.value)}
                          >
                            <option value={""}></option>
                            {Array.from(new Set(raritiesForFilter.map((rarity) => rarity.name))).map((rarityName) => (
                              <option value={rarityName} key={rarityName}>
                                {titleize(rarityName)}
                              </option>
                            ))}
                          </select>
                        </div>
                      }

                      {
                        versions && versions.length > 1 &&
                        <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                          <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.sort.version')}</p>
                          <select
                            className={`form-control filter-input ${filters.version ? 'selected-label' : 'border-none'} pl-2`}
                            value={filters.version ? filters.version : ""}
                            name="version_filter"
                            id="version_filter"
                            disabled={versionsForFilter.length === 0}
                            onChange={(e) => getProductsByMatchingFilters('version', e.target.value)}
                          >
                            <option value={""}></option>
                            {Array.from(new Set(versionsForFilter.map((version) => version.name))).map((versionName) => (
                              <option value={versionName} key={versionName}>
                                {titleize(versionName)}
                              </option>
                            ))}
                          </select>
                        </div>
                      }

                      <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                        <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.sort.gradeFrom')}</p>
                        <select
                          className={`form-control filter-input ${filters.grade_from ? 'selected-label' : 'border-none'} pl-2`}
                          value={filters.grade_from ? filters.grade_from : ""}
                          name="grade_from_filter"
                          id="grade_from_filter"
                          onChange={(e) => getProductsByMatchingFilters('grade_from', e.target.value)}
                        >
                          <option value={""}></option>
                          {Array.from({ length: 19 }, (_, i) => 1 + i * 0.5).map((grade) => (
                            <option value={grade} key={grade}>
                              {grade}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                        <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.sort.gradeTo')}</p>
                        <select
                          className={`form-control filter-input ${filters.grade_to ? 'selected-label' : 'border-none'} pl-2`}
                          value={filters.grade_to ? filters.grade_to : ""}
                          name="grade_to_filter"
                          id="grade_to_filter"
                          onChange={(e) => getProductsByMatchingFilters('grade_to', e.target.value)}
                        >
                          <option value={""}></option>
                          {Array.from({ length: 19 }, (_, i) => 1 + i * 0.5).map((grade) => (
                            <option value={grade} key={grade}>
                              {grade}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                        <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.sort.encasing')}</p>
                        <select
                          className={`form-control filter-input ${filters.encasing ? 'selected-label' : 'border-none'} pl-2`}
                          value={filters.encasing ? filters.encasing : ""}
                          name="encasing_filter"
                          id="encasing_filter"
                          onChange={(e) => getProductsByMatchingFilters('encasing', e.target.value)}
                        >
                          <option value={""}></option>
                          {[[I18n.t('js.common.submissionListType.sleeve') + ' / ' + I18n.t('js.common.submissionListType.sleeveExplanation'), 'sleeve'],
                          [I18n.t('js.common.submissionListType.case') + ' ' + I18n.t('js.common.submissionListType.caseExplanation'), 'case']].map((encasing) => (
                            <option value={encasing[1]} key={encasing[1]}>
                              {encasing[0]}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                        <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.sort.labelLanguage')}</p>
                        <select
                          className={`form-control filter-input ${filters.label_language ? 'selected-label' : 'border-none'} pl-2`}
                          value={filters.label_language ? filters.label_language : ""}
                          name="label_language_filter"
                          id="label_language_filter"
                          onChange={(e) => getProductsByMatchingFilters('label_language', e.target.value)}
                        >
                          <option value={""}></option>
                          {label_languages.map((label_language) => (
                            <option value={label_language} key={label_language}>
                              {label_language.toUpperCase()}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                        <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.inSubmissionList')}</p>
                        <select
                          className={`form-control filter-input ${filters.in_submission_list ? 'selected-label' : 'border-none'} pl-2`}
                          value={filters.in_submission_list ? filters.in_submission_list : ""}
                          name="in_submission_list_filter"
                          id="in_submission_list_filter"
                          onChange={(e) => getProductsByMatchingFilters('in_submission_list', e.target.value)}
                        >
                          <option value={""}></option>
                          {[[I18n.t('js.common.choice_yes'), true], [I18n.t('js.common.choice_no'), false]].map((choice) => (
                            <option value={choice[1]} key={choice[1]}>
                              {choice[0]}
                            </option>
                          ))}
                        </select>
                      </div> */}

                      {closedSubmissionsList.length > 0 &&
                        <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                          <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.submissionListNumber')}</p>
                          <select
                            className={`form-control filter-input ${filters.submission_list_id ? 'selected-label' : 'border-none'} pl-2`}
                            value={filters.submission_list_id ? filters.submission_list_id : ""}
                            name="submission_list_id_filter"
                            id="submission_list_id_filter"
                            onChange={(e) => getProductsByMatchingFilters('submission_list_id', e.target.value)}
                          >
                            <option value={""}></option>
                            {closedSubmissionsList.map((submission_list) => (
                              <option value={submission_list[0]} key={submission_list[0]}>
                                {submission_list[1]}
                              </option>
                            ))}
                          </select>
                        </div>
                      }

                      {
                        enableSaleFunctionalities && (availableSaleChannels.length > 0 || presentSaleItems) &&
                        <React.Fragment>
                          {availableSaleChannels.length === 1 ?
                            <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                              <p
                                className="mb-1 ml-1 filter-label">{I18n.t('js.filters.listedOn')} {availableSaleChannels[0].meta_name}</p>
                              <select
                                className={`form-control filter-input ${filters.on_sale_on_sale_channel ? 'selected-label' : 'border-none'} pl-2`}
                                value={filters.on_sale_on_sale_channel ? filters.on_sale_on_sale_channel : ""}
                                name="on_sale_on_sale_channel_filter"
                                id="on_sale_on_sale_channel_filter"
                                onChange={(e) => getProductsByMatchingFilters('on_sale_on_sale_channel', e.target.value)}
                              >
                                <option value={""}></option>
                                {[[I18n.t('js.common.choice_yes'), true], [I18n.t('js.common.choice_no'), false]].map((choice) => (
                                  <option value={choice[1]} key={choice[1]}>
                                    {choice[0]}
                                  </option>
                                ))}
                              </select>
                            </div>
                            :
                            <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                              <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.listedOn')}</p>
                              <select
                                className={`form-control filter-input ${filters.on_sale_on_sale_channel_id ? 'selected-label' : 'border-none'} pl-2`}
                                value={filters.on_sale_on_sale_channel_id ? filters.on_sale_on_sale_channel_id : ""}
                                name="on_sale_on_sale_channel_id_filter"
                                id="on_sale_on_sale_channel_id_filter"
                                onChange={(e) => getProductsByMatchingFilters('on_sale_on_sale_channel_id', e.target.value)}
                              >
                                <option value={""}></option>
                                {saleChannelByUserSaleItems.map((sale_channel) => (
                                  <option value={sale_channel[0]} key={sale_channel[0]}>
                                    {sale_channel[1]}
                                  </option>
                                ))}
                              </select>
                            </div>
                          }
                        </React.Fragment>
                      }

                      {
                        enableProFunctionalities &&
                        <React.Fragment>
                          <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                            <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.sort.condition')}</p>
                            <select
                              className={`form-control filter-input ${filters.condition ? 'selected-label' : 'border-none'} pl-2`}
                              value={filters.condition ? filters.condition : ""}
                              name="condition_filter"
                              id="condition_filter"
                              onChange={(e) => getProductsByMatchingFilters('condition', e.target.value)}
                            >
                              <option value={""}></option>
                              {[[I18n.t('js.myCollectionEditPage.condition.new'), 'new'],
                              [I18n.t('js.myCollectionEditPage.condition.used'), 'used']].map((condition) => (
                                <option value={condition[1]} key={condition[1]}>
                                  {condition[0]}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                            <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.sort.batch')}</p>
                            <input
                              type="text"
                              value={filters.batch ? filters.batch : ""}
                              className={`form-control filter-input ${filters.batch ? 'selected-label' : 'border-none'}`}
                              onChange={(e) => onChangeDebouncedFilterHandler('batch', e.target.value)}
                              name="batch_filter"
                              id="batch_filter"
                            />
                          </div>

                          <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                            <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.sort.minValue')}</p>
                            <input
                              type="number"
                              min="0"
                              value={filters.min_price ? filters.min_price : ""}
                              className={`form-control filter-input ${filters.title ? 'selected-label' : 'border-none'}`}
                              onChange={(e) => onChangeDebouncedFilterHandler('min_price', e.target.value)}
                              name="min_price_filter"
                              id="min_price_filter"
                            />
                          </div>
                        </React.Fragment>
                      }

                      {
                        enableLoopMerchantFunctionalities &&
                        <React.Fragment>
                          <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                            <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.sort.minPrice')}</p>
                            <input
                              type="number"
                              min="0"
                              value={filters.min_price ? filters.min_price : ""}
                              className={`form-control filter-input ${filters.title ? 'selected-label' : 'border-none'}`}
                              onChange={(e) => onChangeDebouncedFilterHandler('min_price', e.target.value)}
                              name="min_price_filter"
                              id="min_price_filter"
                            />
                          </div>
                        </React.Fragment>
                      }

                      <div className="col-6 col-md-3 col-lg-2 mb-2 pt-1 pb-2 px-2">
                        <p className="mb-1 ml-1 filter-label">{I18n.t('js.filters.sort.resultsPerPage')}</p>
                        <select
                          className={`form-control filter-input ${filters.per_page != DEFAULT_PER_PAGE_PARAM ? 'selected-label' : 'border-none'} pl-2`}
                          value={filters.per_page ? filters.per_page : DEFAULT_PER_PAGE_PARAM}
                          name="per_page_filter"
                          id="per_page_filter"
                          onChange={(e) => getProductsByMatchingFilters('per_page', e.target.value)}
                        >
                          {[50, 100, 200, 300, 500].map((perPageOption) => (
                            <option value={perPageOption} key={perPageOption}>
                              {perPageOption}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            {/*  SEZIONE DEDICATA ALLA GESTIONE DEI RISULTATI RENDERIZZATI SULLA PAGINA */}
            <div
              className="mt-4 mb-3 d-block d-lg-flex justify-content-start justify-content-sm-between align-items-center border-bottom-2px-lightgray3">
              <div className="d-flex justify-content-between align-items-center pb-3 px-0">
                <div className="align-items-center">
                  <b>{allProductsIds.length}</b>&nbsp;
                  {pluralize(allProductsIds.length, 'editSubmissionListPage.product').toLowerCase()}
                </div>
              </div>
              {
                allProductsIds?.length > 0 &&
                <div className="d-block d-lg-flex justify-content-center align-items-center justify-content-sm-end pb-3 px-0">
                  {(enableProFunctionalities || enableLoopMerchantFunctionalities) && (
                    <div className="d-flex align-items-end align-items-sm-center mr-3 mb-3 mb-lg-0 text--white-space-no-wrap">
                      <p className="my-0 mr-2">
                        {I18n.t('js.myCollectionEditPage.showPrices')}
                      </p>
                      <label className="switch my-0">
                        <input
                          type="checkbox"
                          checked={showLoopPrices}
                          id="show_loop_prices_selector"
                          name="show_loop_prices_selector"
                          onChange={() => setShowLoopPrices(!showLoopPrices)}
                        />
                        <span className='slider round'></span>
                      </label>
                    </div>
                  )}

                  {enableProFunctionalities && (
                    <div className="d-flex align-items-end align-items-sm-center mr-3 mb-3 mb-lg-0 text--white-space-no-wrap">
                      <p className="my-0 mr-2">
                        {I18n.t('js.myCollectionEditPage.showConditionAndBatch')}
                      </p>
                      <label className="switch my-0">
                        <input
                          type="checkbox"
                          checked={showProData}
                          id="show_pro_data_selector"
                          name="show_pro_data_selector"
                          onChange={() => setShowProData(!showProData)}
                        />
                        <span className='slider round'></span>
                      </label>
                    </div>
                  )}

                  {enableSaleFunctionalities && presentSaleItems && (
                    <div className="d-block d-sm-flex mb-3 mb-lg-0">
                      <div className="d-flex align-items-end align-items-sm-center mr-3 mb-3 mb-sm-0 text--white-space-no-wrap">
                        <p className="my-0 mr-2">
                          {I18n.t('js.myCollectionEditPage.showListings')}
                        </p>
                        <label className="switch my-0">
                          <input
                            type="checkbox"
                            checked={showSaleData}
                            id="show_sale_data_selector"
                            name="show_sale_data_selector"
                            onChange={(e) => setShowSaleData(!showSaleData)}
                          />
                          <span className='slider round'></span>
                        </label>
                      </div>

                      {availableSaleChannels.length > 0 &&
                        <UpdateSaleItemsStateButton
                          userId={userId}
                          reloadPageUrl={`/users/${userId}/certificates?show_listings=true`}
                          setShowErrorModal={setShowErrorModal}
                        />
                      }
                    </div>
                  )}

                  <div className="d-flex">
                    <select
                      className={`form-control minW-sm-180px gray-label ${viewModeSelected ? 'selected-label' : ''} mr-3`}
                      name="view_as"
                      id="view_as"
                      value={viewMode ? viewMode : ''}
                      onChange={(e) => {
                        setViewMode(e.target.value);
                        setViewModeSelected(true);
                        setCardsAnimationDivider(Number.MAX_SAFE_INTEGER);
                      }}>
                      <option value="" disabled hidden>{I18n.t('js.filters.viewMode.zoom')}</option>
                      {['large', 'medium', 'shrinked_medium'].map(option => {
                        return <option value={option} key={option}>
                          {I18n.t(`js.filters.viewMode.${option}`)}
                        </option>
                      })}
                    </select>


                    <select
                      className={`form-control minW-sm-180px gray-label ${filters.sort_by ? 'selected-label' : ''}`}
                      name="sort_by"
                      id="sort_by"
                      value={filters.sort_by ? filters.sort_by : ''}
                      onChange={(e) => getProductsByMatchingFilters('sort_by', e.target.value)}>
                      <option value="" disabled hidden>{I18n.t('js.indexSubmissionListsPage.sortBy')}</option>
                      {sorting_options.map(option => {
                        return <option value={option.value} key={option.value}>{I18n.t(option.locale)}</option>
                      })}
                    </select>


                    {
                      filters.sort_by &&
                      <div className="d-flex justify-content-center align-items-center px-0 cursor-pointer ml-3"
                        onClick={(e) => getProductsByMatchingFilters('sorting_direction', filters.sorting_direction === 'desc' ? 'asc' : 'desc')}>
                        <div className="d-flex justify-content-center align-items-center blue-label minW-40px-imp">
                          <p className="my-0" id={`sorting_direction_${filters.sorting_direction === 'desc' ? 'desc' : 'asc'}`}>
                            {filters.sorting_direction === 'desc' ? '↓' : '↑'} {I18n.t(`js.filters.sort.${filters.sorting_direction}endingSuperCompact`)}
                          </p>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>




          {/*  SEZIONE DEDICATA ALL'ELENCO DI TUTTI I PRODOTTI PRESENTI ALL'INTERNO DELLA MY COLLECTION LE SUBMISSION LISTS */}
          <div id="my_collection_container">
            {
              (loading || changeViewMode) ?
                <div className="d-flex justify-content-center my-5">
                  <div className="d-flex align-items-center text-intense-blue text-weight-500">
                    <div className="spinner-border" role="status" />
                    <b className="ml-2">{I18n.t('js.myCollectionEditPage.loading')}</b>
                  </div>
                </div>
                :
                products.length > 0 ?
                  <BottomScrollListener onBottom={!renderActionsBar ? getProducts : () => { }}>

                    <div className={`my-collection-products-grid my-collection-products-grid--${viewMode ? viewMode : 'medium'} w-100 p-0 mx-0 mt-0 mb-5`} id="my-collection-products-list">
                      {
                        products.map((product, i) => {
                          const blueprintImage = product.blueprint_image;
                          const currentGrading = product.current_grading;
                          const notEditableSaleItems = product.sale_items.filter(saleItem => !saleItem.allow_changes)

                          return <div key={`product_${product.id}`} id={`product_${product.id}`}
                            className={`card-${viewMode ? viewMode : 'medium'}-container
                                      d-flex justify-content-center align-items-start mt-1 mb-2 px-0 ${selectedProductsIds?.includes(product.id) ? 'selected_product' : ''}`}
                          >
                            <div className={`my-collection-card-container 
                                 ${selectedProductsIds?.includes(product.id) ? `bg-${is10Perfect(product.current_grading) ? 'gold-' : ''}aig-gradient` : `bg-${is10Perfect(product.current_grading) ? 'gold-' : ''}aig-gradient-light`} br-8px shadow p-0 
                                 max-w-${viewMode === 'shrinked_medium' ? '124' : (viewMode === 'large' ? '267' : '189')}px
                                 cursor-pointer`}
                              // style={{ animation: `scale-up 0.5s ease-out ${0.100 * (i % cardsAnimationDivider)}s forwards` }}
                              id={`product_header_${product.id}`}
                              onClick={(e) => {
                                handleSelectProduct(product);
                                e.stopPropagation();
                              }}
                              onMouseOver={() => handleDisplayProductContent(product, true, true)}
                              onMouseOut={() => handleDisplayProductContent(product, false, true)}
                            >
                              <div className={`row w-100 py-2 font-size-${viewMode === 'large' ? '12' : '10'}px m-0`}>
                                <div className={`${viewMode === 'shrinked_medium' ? 'd-none' : 'col-9'} pl-2 pr-0 py-0 m-0 text-uppercase line-height-1_4`} id={`product_details_container_${product.id}`}>
                                  <div className="d-flex justify-content-start align-items-center p-0 m-0 minH-26px-imp">
                                    <p className="m-0 p-0 font-weight-bold text-truncate"
                                      name={blueprintImage.en_name ? blueprintImage.en_name : blueprintImage.meta_name + (viewMode === 'large' ? ' ' + blueprintImage.collector_number : '')}
                                    >
                                      <IconTooltip
                                        tooltipContent={blueprintImage.en_name ? blueprintImage.en_name : blueprintImage.meta_name + (viewMode === 'large' ? ' ' + blueprintImage.collector_number : '')}
                                        customTxt={blueprintImage.en_name ? blueprintImage.en_name : blueprintImage.meta_name + (viewMode === 'large' ? ' ' + blueprintImage.collector_number : '')}
                                        customTxtId={'name'}
                                      />
                                    </p>
                                    {
                                      viewMode === 'large' &&
                                      <React.Fragment>
                                        <IconTooltip
                                          tooltipContent={fullName(blueprintImage.en_expansion_name, blueprintImage.expansion_name, blueprintImage.language)}
                                          customComponentToRenderCssClass={''}
                                          customComponentToRender={
                                            <ExpansionIcon
                                              icon_url={blueprintImage.expansion.icon_url}
                                              width={"21px"}
                                              cssClassList={'ml-2 mb-5px'}
                                            />
                                          }
                                        />
                                        <IconTooltip
                                          tooltipContent={parseLanguageAcronim(blueprintImage.language)}
                                          customComponentToRenderCssClass={''}
                                          customComponentToRender={
                                            <LanguageFlag
                                              language={blueprintImage.language}
                                              maxHeight={'14px'}
                                              containerCssClassList={'m-0 py-0 pl-2 pr-0 mb-3px-imp'}
                                              displayRoundFlag={true}
                                            />
                                          }
                                        />
                                      </React.Fragment>
                                    }
                                  </div>

                                  <div className="my-0 color-dark-gray-2 text-truncate" id={`product_details_${product.id}`}>
                                    {
                                      viewMode === 'large' ?
                                        (blueprintImage.version ?
                                          <span>{titleize(blueprintImage.version)}</span>
                                          :
                                          <span>&nbsp;</span>)
                                        :
                                        <div className="d-flex justify-content-start align-items-center p-0 m-0 minH-26px-imp">
                                          <IconTooltip
                                            tooltipContent={fullName(blueprintImage.en_expansion_name, blueprintImage.expansion_name, blueprintImage.language)}
                                            customComponentToRenderCssClass={''}
                                            customComponentToRender={
                                              <ExpansionIcon
                                                icon_url={blueprintImage.expansion.icon_url}
                                                width={"21px"}
                                                cssClassList={'mr-2 mb-5px'}
                                              />
                                            }
                                          />
                                          <IconTooltip
                                            tooltipContent={titleize(blueprintImage.rarity)}
                                            customComponentToRenderCssClass={''}
                                            customComponentToRender={
                                              <RarityIcon
                                                icon_url={blueprintImage.rarity_logo_url}
                                                width={'14px'}
                                                cssClassList={'mr-2 mb-8px'}
                                              />
                                            }
                                          />
                                          <IconTooltip
                                            tooltipContent={parseLanguageAcronim(blueprintImage.language)}
                                            customComponentToRenderCssClass={''}
                                            customComponentToRender={
                                              <LanguageFlag
                                                language={blueprintImage.language}
                                                maxHeight={'14px'}
                                                containerCssClassList={'m-0 py-0 mb-3px-imp'}
                                                displayRoundFlag={true}
                                              />
                                            }
                                          />
                                        </div>
                                    }
                                  </div>

                                  {
                                    viewMode === 'large' &&
                                    <React.Fragment>
                                      <div className="my-0 color-dark-gray-2 text-truncate" id={`product_rarity_${product.id}`}>
                                        {
                                          blueprintImage.rarity && !compareStrings(blueprintImage.rarity, 'no rarity') ?
                                            <div className="d-flex justify-content-start align-items-center p-0 m-0">
                                              {titleize(blueprintImage.rarity)}&nbsp;
                                              <RarityIcon
                                                icon_url={blueprintImage.rarity_logo_url}
                                                width={'14px'}
                                                cssClassList={'ml-1 mb-8px'}
                                              />
                                            </div>
                                            :
                                            <span>&nbsp;</span>

                                        }
                                      </div>

                                      <div className="my-0 color-dark-gray-2 text-truncate" id={`product_edition_${product.id}`}>
                                        {
                                          blueprintImage.edition && !compareStrings(blueprintImage.edition, 'undefined') ?
                                            <span>{titleize(blueprintImage.edition)}</span>
                                            :
                                            <span>&nbsp;</span>

                                        }
                                      </div>
                                    </React.Fragment>
                                  }
                                </div>

                                <div className={`col-${viewMode === 'shrinked_medium' ? '12' : '3 pr-4'} d-flex justify-content-center align-items-center text-center`}>
                                  {
                                    is10Perfect(product.current_grading) ?
                                      <IconTooltip
                                        tooltipContent={`10 ${product.current_grading?.evaluations ? product.current_grading?.evaluations[0] : getGradingNameFromGrade('10.5', true)[0]}`}
                                        customComponentToRenderCssClass={'fake-class'}
                                        customComponentToRender={
                                          <GradeOverallContainer
                                            product={product}
                                            viewMode={viewMode}
                                            handleDisplayProductActionsMenu={handleDisplayProductActionsMenu}
                                            actionMenuProduct={actionMenuProduct}
                                          />
                                        }
                                      />
                                      :
                                      <GradeOverallContainer
                                        product={product}
                                        viewMode={viewMode}
                                        handleDisplayProductActionsMenu={handleDisplayProductActionsMenu}
                                        actionMenuProduct={actionMenuProduct}
                                      />
                                  }
                                </div>
                              </div>

                              <div className="w-100 bg-white p-2 position-relative br-8px"
                                onMouseOver={() => handleDisplayProductContent(product, true)}
                              >
                                <div className={`d-none bg-${is10Perfect(product.current_grading) ? 'gold-' : ''}aig-gradient-light certificate-actions-menu-container px-3 border-aiG-${is10Perfect(product.current_grading) ? 'orange' : 'blue'}-imp shadow br-8px overflow-hidden`}
                                  id={`actions_menu_${product.id}`}>
                                  {(() => {
                                    const hasLoopPriceAction = enableLoopMerchantFunctionalities || enableProFunctionalities;
                                    const saleChannelsCount = enableSaleFunctionalities ? availableSaleChannels.length : 0;
                                    const totalActions = 2 + (hasLoopPriceAction ? 1 : 0) + saleChannelsCount;
                                    const maxIndex = totalActions - 1;
                                    const loopPriceIndex = 2;
                                    const saleChannelBaseIndex = hasLoopPriceAction ? 3 : 2;

                                    return (
                                      <div className='row'>
                                        {/* View Certificate */}
                                        <ProductActionMenu
                                          viewMode={viewMode}
                                          product={product}
                                          iconUrl={`/images/icons/grading_certificate${is10Perfect(product.current_grading) ? '_gold' : ''}.svg`}
                                          title={I18n.t('js.indexSaleItems.actionsMenu.viewCertificateTitle')}
                                          description={I18n.t('js.indexSaleItems.actionsMenu.viewCertificateDescription')}
                                          handleClick={() => {
                                            setProductToShowGradingCertificate(product);
                                            setShowCertificate(true);
                                          }}
                                          index={0}
                                          maxIndex={maxIndex}
                                        />

                                        {/* Transfer Certificate */}
                                        <ProductActionMenu
                                          viewMode={viewMode}
                                          product={product}
                                          iconUrl={`/images/icons/transfer_certificate${is10Perfect(product.current_grading) ? '_gold' : ''}.svg`}
                                          title={I18n.t('js.indexSaleItems.actionsMenu.transferCertificateTitle')}
                                          description={I18n.t('js.indexSaleItems.actionsMenu.transferCertificateDescription')}
                                          handleClick={() => {
                                            setProductToTransferCertificate(product);
                                            setShowTransferCertificatesModal(true);
                                          }}
                                          index={1}
                                          maxIndex={maxIndex}
                                        />

                                        {/* Edit Loop Price */}
                                        {hasLoopPriceAction &&
                                          <ProductActionMenu
                                            viewMode={viewMode}
                                            product={product}
                                            iconUrl={`/images/icons/edit.svg`}
                                            title={I18n.t('js.loopPriceModal.menuTitle')}
                                            description={I18n.t('js.loopPriceModal.menuDescription')}
                                            handleClick={() => {
                                              setProductsToEditLoopPrice([product]);
                                              setShowLoopPriceEditModal(true);
                                            }}
                                            index={loopPriceIndex}
                                            maxIndex={maxIndex}
                                          />
                                        }

                                        {/* Sell item */}
                                        {enableSaleFunctionalities && availableSaleChannels.map((saleChannel, index) => {
                                          const saleItem = product.sale_items.filter(sale_item => sale_item.sale_channel.id === saleChannel.id)[0];

                                          return (
                                            (notEditableSaleItems.length === 0 || saleItem?.sale_channel.id === saleChannel.id) &&
                                            <ProductActionMenu
                                              key={`product_action_menu_${product.id}_${index}`}
                                              viewMode={viewMode}
                                              product={product}
                                              iconUrl={saleChannel.thumb_icon_url}
                                              saleItem={saleItem}
                                              saleChannel={saleChannel}
                                              isSaleChannel={true}
                                              title={I18n.t('js.indexSaleItems.actionsMenu.saleChannelSellOnTitle').replace(':sale_channel', saleChannel.meta_name.toUpperCase())}
                                              description={I18n.t('js.indexSaleItems.actionsMenu.saleChannelSellOnDescription').replace(':sale_channel', saleChannel.meta_name)}
                                              handleClick={(saleItem) => {
                                                handleCreateSaleItems(saleChannel.id, [product], saleItem);
                                              }}
                                              index={index + saleChannelBaseIndex}
                                              maxIndex={maxIndex}
                                            />
                                          )
                                        })}
                                      </div>
                                    );
                                  })()}
                                </div>

                                <div className="position-relative">
                                  <ShowBlueprintImageFrontImage
                                    size={viewMode ? viewMode : 'medium'}
                                    blueprintImage={currentGrading[`${viewMode ? viewMode : 'medium'}_image_url`] ? currentGrading : blueprintImage}
                                    cursor={'pointer'}
                                    textOverlayPlaceholder={getArtwork(blueprintImage)}
                                  />

                                  {(() => {
                                    const showLoopPrice = showLoopPrices && (enableProFunctionalities || enableLoopMerchantFunctionalities) && isDefined(product.price) && product.price > 0 && product.id !== actionMenuProduct?.id;
                                    const showSaleItems = showSaleData && enableSaleFunctionalities && product.sale_items?.length > 0;
                                    const hasBothBanners = showLoopPrice && showSaleItems;
                                    const showProDataBanner = showProData && enableProFunctionalities && isDefined(product.condition) && product.id !== actionMenuProduct?.id;

                                    // Banner con condizione e lotto del prodotto, stessa struttura di quello degli annunci,
                                    // impilato sopra i banner degli annunci e del prezzo loop
                                    const proDataBanner = showProDataBanner && (
                                      <div className="p-1 shadow br-8px mb-1px bg-dark" id={`product_content_${product.id}`}>
                                        <div className="align-items-center d-flex">
                                          <div className={`col-${viewMode === 'shrinked_medium' ? 4 : 3} d-flex justify-content-center`}>
                                            <div className="d-flex flex-directions-column bg-aig-gradient p-1px br-50perc shadow">
                                              <div className={`d-flex justify-content-center flex-fill align-items-center br-50perc bg-white grading-container-${viewMode === 'large' ? viewMode : 'medium'}`}>
                                                <img src="/images/icons/box.png" className="opacity-1-imp" alt="" width={`${viewMode === 'large' ? '30px' : '20px'}`} />
                                              </div>
                                            </div>
                                          </div>
                                          <div className={`col-${viewMode === 'shrinked_medium' ? 8 : 9} d-flex flex-column ${viewMode === 'large' ? 'pl-0' : 'pl-1 pr-0'} font-size-${viewMode === 'shrinked_medium' ? 10 : 12}px color-white`}>
                                            <b style={{ overflow: 'hidden', textOverflow: 'ellipsis' }} id={`product_condition_${product.id}`}>
                                              {I18n.t(`js.myCollectionEditPage.condition.${product.condition}`).toUpperCase()}
                                            </b>
                                            <div>
                                              {
                                                isDefined(product.batch) && product.condition === 'used' &&
                                                <p className={`${viewMode === 'shrinked_medium' ? 'd-none' : ''} m-0`}>
                                                  {I18n.t('js.myCollectionEditPage.tableHeaderBatch') + ' ' + product.batch}
                                                </p>
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );

                                    const withProDataBanner = (banners) => proDataBanner ?
                                      <div className="certificate-banners-container certificate-banners-stack">
                                        {proDataBanner}
                                        {banners}
                                      </div>
                                      :
                                      banners;

                                    const priceParts = (() => {
                                      let fixed = product.price?.toFixed(2);
                                      fixed = fixed ? fixed : '0.00';
                                      const [integer, decimals] = fixed.split('.');
                                      return { integer, decimals };
                                    })();

                                    const loopPriceBanner = (
                                      <div className={`e-ink-smart-label e-ink-smart-label--mini ${hasBothBanners ? 'br-bottom-8px' : 'br-8px'}`}>
                                        <div className="e-ink-smart-label__inner e-ink-smart-label__inner--mini">
                                          <div className="e-ink-smart-label__price e-ink-smart-label__price--mini">
                                            <span className="e-ink-smart-label__price-integer">{priceParts.integer},</span>
                                            <span className="e-ink-smart-label__price-decimals">{priceParts.decimals}</span>
                                            <span className="e-ink-smart-label__price-currency">€</span>
                                          </div>
                                        </div>
                                      </div>
                                    );

                                    if (hasBothBanners) {
                                      return withProDataBanner(
                                        <div className="certificate-banners-container">
                                          {product.sale_items.map((sale_item, index) => {
                                            const isLastItem = index === product.sale_items.length - 1;
                                            return (
                                              <React.Fragment key={`sale_status_${sale_item.id}`}>
                                                {product.id !== actionMenuProduct?.id && (
                                                  <div
                                                    className={`p-1 shadow ${isLastItem ? 'br-top-8px' : 'mb-1px br-8px'}`}
                                                    style={{ backgroundColor: saleItemColorState(sale_item.state) }}
                                                    id={`sale_status_${sale_item.id}`}
                                                  >
                                                    <div className="align-items-center d-flex">
                                                      <div className={`col-${viewMode === 'shrinked_medium' ? 4 : 3} d-flex justify-content-center`}>
                                                        <div className="d-flex flex-directions-column bg-aig-gradient p-1px br-50perc shadow">
                                                          <div className={`d-flex justify-content-center flex-fill align-items-center br-50perc bg-white grading-container-${viewMode === 'large' ? viewMode : 'medium'}`}>
                                                            <img src={sale_item.sale_channel?.thumb_icon_url} className="opacity-1-imp" alt="" width={`${viewMode === 'large' ? '30px' : '20px'}`} />
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className={`col-${viewMode === 'shrinked_medium' ? 8 : 9} d-flex flex-column ${viewMode === 'large' ? 'pl-0' : 'pl-1 pr-0'} font-size-${viewMode === 'shrinked_medium' ? 10 : 12}px color-white`}>
                                                        <b style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                          {saleItemTitleToRender(sale_item)}
                                                        </b>
                                                        <div>
                                                          {saleItemAttributesToRender(sale_item, viewMode)?.filter(attributeToRender => isDefined(attributeToRender))?.map((attributeToRender, attrIndex) => {
                                                            return (
                                                              <p className={`${viewMode === 'shrinked_medium' ? 'd-none' : ''} m-0`} key={`${sale_item.id}_${attrIndex}`}>
                                                                {attributeToRender}
                                                              </p>
                                                            )
                                                          })}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                              </React.Fragment>
                                            )
                                          })}
                                          {loopPriceBanner}
                                        </div>
                                      );
                                    }

                                    return withProDataBanner(
                                      <>
                                        {showSaleItems && (
                                          <div className="certificate-sale-data-container">
                                            {product.sale_items.map((sale_item, index) => {
                                              return (
                                                <React.Fragment key={`sale_status_${sale_item.id}`}>
                                                  {product.id !== actionMenuProduct?.id && (
                                                    <div
                                                      className={`p-1 shadow br-8px ${index !== product.sale_items.length - 1 ? 'mb-1px' : ''}`}
                                                      style={{ backgroundColor: saleItemColorState(sale_item.state) }}
                                                      id={`sale_status_${sale_item.id}`}
                                                    >
                                                      <div className="align-items-center d-flex">
                                                        <div className={`col-${viewMode === 'shrinked_medium' ? 4 : 3} d-flex justify-content-center`}>
                                                          <div className="d-flex flex-directions-column bg-aig-gradient p-1px br-50perc shadow">
                                                            <div className={`d-flex justify-content-center flex-fill align-items-center br-50perc bg-white grading-container-${viewMode === 'large' ? viewMode : 'medium'}`}>
                                                              <img src={sale_item.sale_channel?.thumb_icon_url} className="opacity-1-imp" alt="" width={`${viewMode === 'large' ? '30px' : '20px'}`} />
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div className={`col-${viewMode === 'shrinked_medium' ? 8 : 9} d-flex flex-column ${viewMode === 'large' ? 'pl-0' : 'pl-1 pr-0'} font-size-${viewMode === 'shrinked_medium' ? 10 : 12}px color-white`}>
                                                          <b style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                            {saleItemTitleToRender(sale_item)}
                                                          </b>
                                                          <div>
                                                            {saleItemAttributesToRender(sale_item, viewMode)?.filter(attributeToRender => isDefined(attributeToRender))?.map((attributeToRender, attrIndex) => {
                                                              return (
                                                                <p className={`${viewMode === 'shrinked_medium' ? 'd-none' : ''} m-0`} key={`${sale_item.id}_${attrIndex}`}>
                                                                  {attributeToRender}
                                                                </p>
                                                              )
                                                            })}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )}
                                                </React.Fragment>
                                              )
                                            })}
                                          </div>
                                        )}

                                        {showLoopPrice && (
                                          <div className="certificate-loop-price-container">
                                            {loopPriceBanner}
                                          </div>
                                        )}
                                      </>
                                    );
                                  })()}
                                </div>
                              </div>
                            </div>
                          </div>
                        })
                      }
                    </div>

                    {
                      !hasLoadedAllProducts && products.length > 0 &&
                      <div className="d-flex justify-content-center my-5">
                        {
                          (!renderActionsBar || loadingMore) ?
                            <div className="d-flex align-items-center text-intense-blue text-weight-500 mt-0 mb-5">
                              <div className="spinner-border" role="status" />
                              <b className="ml-2">{I18n.t('js.myCollectionEditPage.loading')}</b>
                            </div>
                            :
                            !loadingMore &&
                            <div className="d-flex align-items-center cursor-pointer mb-5" onClick={() => {
                              setLoadingMore(true);
                              getProducts();
                            }}>
                              <span className="text-intense-blue text-weight-500 pt-1">
                                {I18n.t('js.common.loadMore')}
                              </span>
                            </div>
                        }
                      </div>
                    }
                  </BottomScrollListener>
                  :
                  <div className="d-flex justify-content-center">
                    <div className="d-flex align-items-center text-muted ml-md-3 mr-md-3 mt-md-4 text-center text-space">
                      <b className="ml-2">{I18n.t('js.myCollectionEditPage.noResultsFound')}</b>
                    </div>
                  </div>
            }
          </div>




          {/*  BOTTONE CHE PERMETTE ALL'UTENTE DI SCROLLARE VELOCEMENTE FINO IN CIMA ALLA PAGINA */}
          {
            !renderActionsBar && !onTopPage &&
            <div id="scrollerOnTopContainer" className="shadow">
              <IconTooltip
                tooltipContent={I18n.t('js.myCollectionEditPage.scrollOnTop')}
                customComponentToRenderCssClass={''}
                customComponentToRender={
                  <React.Fragment>
                    <div className="d-flex justify-content-center text-center cursor-pointer pt-07rem-imp"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      <img src="/images/icons/white/arrow-up-solid-w.svg" className="cursor-pointer" alt=""
                        height="25px" />
                    </div>
                  </React.Fragment>
                }
              />
            </div>
          }
        </div>



        {/* ACTIONS BAR: SEZIONE DEDICATA ALLE FUNZIONI MASSIVE SUI PRODOTTI PRESENTI NELLA COLLECTION */}
        {
          renderActionsBar &&
          <div id="my_collection_actions_bar" className={selectedProducts.length > 0 ? 'visible-actions-bar' : ''}>
            <div className="col-12">
              {/* Bottone visibile solo su ipad e smartphone che permette di aprire / chiudere la actions bar */}
              <div className={`d-flex d-lg-${actionsBarOpen ? 'none' : 'flex'} justify-content-end align-items-center p-0 py-2`}>
                <div className="d-flex align-items-center justify-content-start text-left cursor-pointer"
                  onClick={(e) => setActionsBarOpen(!actionsBarOpen)}>
                  <img src={`/images/icons/black/arrow-${actionsBarOpen ? 'down' : 'up'}.svg`}
                    className="cursor-pointer ml-2" alt="" width="10" height="10" />
                </div>
              </div>


              {/* Prima riga della actions bar, che contiene le funzionalità di selezione / deselezione massiva dei
                  prodotti, di messa in vendita, di trasferimento dei certificati e di download dei dati in csv */}
              <div
                className={`slide-animation-container slide-${actionsBarOpen ? 'down' : 'up'} d-flex align-items-center justify-content-between flex-wrap px-0`}>
                <div className="d-flex align-items-center flex-wrap px-0">
                  <div className="d-flex justify-content-start align-items-center p-0 py-2 mr-5">
                    <label htmlFor="select_all_products" className="text-intense-blue text-weight-500 pt-2">
                      {selectedProducts.length + " " + I18n.t('js.myCollectionEditPage.selectedProducts')}
                    </label>
                  </div>

                  <button
                    id="bulk_select_products_btn"
                    name="bulk_select_products_btn"
                    className="submission_lists_footer_button bg-intense-blue-imp color-white text-weight-500 border-none mr-2 my-1"
                    onClick={() => {
                      handleSelectAllProducts(true), setAllProductsSelected(true)
                    }}
                    onMouseOver={() => setTipMessage(I18n.t('js.myCollectionEditPage.tipMessages.selectAll'))}
                    onMouseOut={() => setTipMessage(defaultTipMessage)}
                  >
                    {I18n.t('js.myCollectionEditPage.selectAllProducts').toUpperCase()}
                  </button>

                  <button
                    id="bulk_deselect_products_btn"
                    name="bulk_deselect_products_btn"
                    className="submission_lists_footer_button bg-intense-blue-imp color-white text-weight-500 border-none mr-2 my-1"
                    onClick={() => {
                      handleSelectAllProducts(false), setAllProductsSelected(false)
                    }}
                    onMouseOver={() => setTipMessage(I18n.t('js.myCollectionEditPage.tipMessages.deselectAll'))}
                    onMouseOut={() => setTipMessage(defaultTipMessage)}
                  >
                    {I18n.t('js.myCollectionEditPage.deselectAllProducts').toUpperCase()}
                  </button>
                </div>

                <div className="d-flex align-items-center flex-wrap px-0">
                  <button
                    id="bulk_transfer_certificates_btn"
                    name="bulk_transfer_certificates_btn"
                    disabled={selectedGradingCertificatesNumbers?.length === 0}
                    className="submission_lists_footer_button bg-intense-blue-imp color-white text-weight-500 border-none mr-2 my-1"
                    onClick={() => setShowTransferCertificatesModal(true)}
                    onMouseOver={() => setTipMessage(I18n.t('js.myCollectionEditPage.tipMessages.bulkTransfer'))}
                    onMouseOut={() => setTipMessage(defaultTipMessage)}
                  >
                    {pluralize(selectedGradingCertificatesNumbers?.length, 'myCollectionEditPage.transferCertificate').toUpperCase()}
                  </button>

                  {
                    enableSaleFunctionalities &&
                    <button
                      id="put_on_sale_on_sale_channels"
                      name="put_on_sale_on_sale_channels"
                      disabled={selectedProductsIds?.length === 0}
                      className="submission_lists_footer_button bg-intense-blue-imp color-white text-weight-500 border-none mr-2 my-1"
                      onClick={() => {
                        if (availableSaleChannels?.length === 1) {
                          handleCreateSaleItems(availableSaleChannels[0].id, selectedProducts)
                        } else {
                          setShowSaleChannelSelectorModal(true)
                        }
                      }}
                      onMouseOver={() => setTipMessage(I18n.t('js.myCollectionEditPage.tipMessages.bulkCreateAnnouncements').replace(':sale_channels', availableSaleChannelsMetaNames))}
                      onMouseOut={() => setTipMessage(defaultTipMessage)}
                    >
                      {I18n.t('js.myCollectionEditPage.putOnSaleOnSaleChannel').toUpperCase()}
                    </button>
                  }

                  {
                    (enableLoopMerchantFunctionalities || enableProFunctionalities) &&
                    <button
                      id="bulk_edit_loop_price_btn"
                      name="bulk_edit_loop_price_btn"
                      disabled={selectedProductsIds?.length === 0}
                      className="submission_lists_footer_button bg-intense-blue-imp color-white text-weight-500 border-none mr-2 my-1"
                      onClick={() => {
                        setProductsToEditLoopPrice(selectedProducts);
                        setShowLoopPriceEditModal(true);
                      }}
                      onMouseOver={() => setTipMessage(I18n.t('js.myCollectionEditPage.tipMessages.bulkEditLoopPrice'))}
                      onMouseOut={() => setTipMessage(defaultTipMessage)}
                    >
                      {I18n.t('js.myCollectionEditPage.bulkEditLoopPrice').toUpperCase()}
                    </button>
                  }

                  <a href={parseProductsUrl('csv', 1, Number.MAX_SAFE_INTEGER)}
                    data-turbolinks="false"
                    className="submission_lists_footer_button bg-intense-blue-imp color-white text-weight-500 border-none my-1"
                    onClick={() => setLoadingCsvData(true)}
                    onMouseOver={() => setTipMessage(I18n.t('js.myCollectionEditPage.tipMessages.bulkCreateCSV'))}
                    onMouseOut={() => setTipMessage(defaultTipMessage)}
                  >
                    {
                      loadingCsvData &&
                      <span className="spinner-border spinner-border-sm mr-2 mb-1" role="status"
                        aria-hidden="true"></span>
                    }
                    {loadingCsvData ? I18n.t('js.advancedSearch.loading').toUpperCase() : I18n.t('js.myCollectionEditPage.exportInCsv').toUpperCase()}
                  </a>

                  <div
                    className="d-flex justify-content-center text-center align-items-center cursor-pointer submission_lists_footer_button bg-intense-blue-imp color-white text-weight-500 border-none minH-35px px-10px-imp ml-2 my-1"
                    onClick={() => scrollHtmlElementIntoView(document, 'pageTitle', false)}
                    onMouseOver={() => setTipMessage(I18n.t('js.myCollectionEditPage.scrollOnTop'))}
                    onMouseOut={() => setTipMessage(defaultTipMessage)}
                  >
                    <img src="/images/icons/white/arrow-up-solid-w.svg" className="cursor-pointer" alt=""
                      height="17px" />
                  </div>
                </div>
              </div>


              {/* Seconda riga della actions bar, visibile solamente agli utenti pro */}
              {
                enableProFunctionalities &&
                  <div className={`row slide-animation-container slide-${actionsBarOpen ? 'down' : 'up'}`}>
                    <hr className="separator my-0 w-100" />
                    <div
                      className="d-flex justify-content-between align-items-center flex-wrap w-100 px-3">
                      <div className="d-flex align-items-center flex-wrap px-0">
                        <div className="d-flex justify-content-start align-items-center p-0 py-2 mr-5">
                          <label htmlFor="select_all_products" className="text-intense-blue text-weight-500 pt-2">
                            {I18n.t('js.myCollectionEditPage.proFeatures')}:
                          </label>
                        </div>
                      </div>

                      <div className="d-flex align-items-center flex-wrap px-0">
                        <select
                          className="form-control filter-input border-none w-auto mr-2 my-1"
                          value={defaultCondition ? defaultCondition : ''}
                          name="condition_select"
                          id="condition_select"
                          onChange={(e) => setDefaultCondition(e.target.value)}
                          onMouseOver={() => setTipMessage(I18n.t('js.myCollectionEditPage.tipMessages.bulkSetCondition'))}
                          onMouseOut={() => setTipMessage(defaultTipMessage)}
                        >
                          <option value="" disabled
                            hidden>{I18n.t('js.myCollectionEditPage.condition.setCondition')}</option>
                          {['new', 'used'].map((condition) => (
                            <option value={condition} key={condition}>
                              {I18n.t(`js.myCollectionEditPage.condition.${condition}`)}
                            </option>
                          ))}
                        </select>

                        <input
                          type="text"
                          value={defaultBatch ? defaultBatch : ''}
                          className="form-control filter-input border-none w-auto my-1"
                          onChange={(e) => setDefaultBatch(e.target.value)}
                          name="product_batch"
                          id="product_batch"
                          placeholder={I18n.t('js.myCollectionEditPage.infoBatchTooltipMenuActionsTitle')}
                          onMouseOver={() => setTipMessage(I18n.t('js.myCollectionEditPage.tipMessages.bulkSetWarehouse'))}
                          onMouseOut={() => setTipMessage(defaultTipMessage)}
                        />
                      </div>
                    </div>
                  </div>
              }


              {/* Terza riga della actions bar, che contiene un messaggio testuale che spiega all'utente ogni
                  funzionalità presente nella actions bar */}
              <div className={`row my-collection-actions-bar-tip slide-animation-container slide-${actionsBarOpen ? 'down' : 'up'}`}>
                <hr className="separator my-0 w-100" />
                <div className="d-flex align-items-center flex-wrap w-100 px-3 py-1">
                  {tipMessage}
                </div>
              </div>
            </div>
          </div>
        }
      </div>


      <ErrorModal
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
      />


      {availableSaleChannels &&
        <SaleChannelSelectorModal
          showModal={showSaleChannelSelectorModal}
          setShowModal={setShowSaleChannelSelectorModal}
          saleChannels={availableSaleChannels}
          selectedProducts={selectedProducts}
          onConfirmHandler={handleCreateSaleItems}
        />
      }


      <SuccessFlashMessage
        showSuccessFlashMessage={showSuccessFlashMessage}
        setShowSuccessFlashMessage={setShowSuccessFlashMessage}
        successMessage={successFlashMessage}
      />

      <GradingCertificate
        originalGradingCertificate={productToShowGradingCertificate ? productToShowGradingCertificate.current_grading : ''}
        originalLabel={productToShowGradingCertificate ? productToShowGradingCertificate.current_label : ''}
        originalBlueprintImage={productToShowGradingCertificate ? productToShowGradingCertificate.blueprint_image : ''}
        showCertificate={showCertificate}
        setShowCertificate={setShowCertificate}
      />

      <TransferCertificatesModal
        showModal={showTransferCertificatesModal}
        toUserBlockchainKey={toUserBlockchainKey}
        setToUserBlockchainKey={setToUserBlockchainKey}
        gradingCertificatesNumbers={productToTransferCertificate ? [productToTransferCertificate?.current_grading?.serial_number] : selectedGradingCertificatesNumbers}
        products={productToTransferCertificate ? [productToTransferCertificate] : selectedProducts}
        handleConfirm={handleTransferGradingCertificates}
        handleCloseModal={handleCloseTransferCertificatesModal}
        errorMessage={transferCertificatesErrorMessage}
      />

      <LoopPriceEditModal
        showModal={showLoopPriceEditModal}
        products={productsToEditLoopPrice}
        handleConfirm={handleUpdateLoopPrice}
        handleCloseModal={handleCloseLoopPriceEditModal}
        isLoading={isUpdatingLoopPrice}
      />

      <FullScreenLoadingOverlay
        showFullScreenLoadingOverlay={creatingSaleItems}
        textFullScreenLoadingOverlay={I18n.t('js.myCollectionEditPage.creatingSaleItems')}
      />
    </React.Fragment>
  );
}

export default MyCollectionPage;